<template>
  <div>
    <a-space class="custom-margin-bottom-16">
      <span class="date">明日日期：</span>
      <span class="date">{{ date }}</span>
      <span class="date">{{ lunar }}</span>
      <span class="date">{{ week }}</span>
    </a-space>

    <a-table
      :columns="columns"
      :data-source="data"
      :pagination="false"
    />
    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findTomorrowServiceOrderDirectorNodes } from '@/api/service_order'
import Pagination from '@/components/Pagination'

export default {
  name: 'TomorrowItem',
  components: {
    Pagination
  },
  data() {
    return {
      data: [],
      date: '',
      lunar: '',
      week: '',
      query: {
        per_page: 10
      },
      pagination: {
        total_count: 0
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '服务时间',
          dataIndex: 'time'
        },
        {
          title: '服务事项',
          dataIndex: 'node_name'
        },
        {
          title: '订单编号',
          dataIndex: 'order_no'
        },
        {
          title: '逝者姓名',
          dataIndex: 'death_name'
        },
        {
          title: '丧属',
          dataIndex: 'master_name'
        },
        {
          title: '负责人',
          dataIndex: 'user_name'
        },
        {
          title: '接单时间',
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
    this.loopFetchData()
  },
  destroyed() {
    clearInterval(this.loopFetchDataTimer)
  },
  methods: {
    loopFetchData() {
      this.loopFetchDataTimer = setInterval(this.fetchData, 60000)
    },

    fetchData() {
      findTomorrowServiceOrderDirectorNodes(this.query).then(res => {
        if (res.code === 0) {
          this.data = res.data.data
          this.date = res.data.tomorrow_date
          this.lunar = res.data.lunar
          this.week = res.data.week
          this.pagination = res.pagination
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.date {
  font-size: 25px;
}
</style>

